import { useLocation } from 'react-router'
import { useEnhancedTracking } from "@/hooks/use-enhanced-tracking"

export default function PageAnalytics() {
  const { pathname } = useLocation()
  const pageName = pathname === "/" ? "Home" : pathname.slice(1).replace(/\//g, " > ")

  useEnhancedTracking({
    pageName,
    userPath: "standard",
    trackScroll: true,
    trackTime: true,
    trackInteractions: true,
  })

  return null
}
